import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[toUppercaseInput]',
  standalone: false
})
export class UppercaseInputDirective {
  private ngControl = inject(NgControl);

  constructor() { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const value = event.target.value.toUpperCase();
    this.ngControl.control.setValue(value, { emitEvent: false });
  }
}
